export default __webpack_public_path__ + "static/media/637.8b71d045.gif";